// extracted by mini-css-extract-plugin
module.exports = {"container":"product-ui-avatar_container__dn7IC","checkmark":"product-ui-avatar_checkmark__zOFmJ","avatarStack":"product-ui-avatar_avatarStack__WtCa5"};